import {setCookie, getCookie} from './cookie.js';
import { extractPkFromLocation } from '../../scripts/helpers/extractPkFromLocation.js';

class Calculators {
  #calculatorsContainer;
  constructor(calculatorsContainer) {
    this.#calculatorsContainer = calculatorsContainer;
  }

  /**
   * Initializes component.
   * init()
   * @param {location} locationObj - should be structured like a window location (https://www.w3schools.com/jsref/obj_location.asp).
   * This parameter must not be set in production environments. Only for testing relevant.
   * @param {function} getCookieFn - should replace getCookie in UnitTest environment. When we can fix the "require not found"-error
   * when using jest.mock we could get rid of this workaround for testing
   */
  init(locationObj = location, getCookieFn = getCookie) {
    const URL_CONFIG = {
      DE: {
        domain: 'easycredit.de',
        pknr: '1.de.4007.1'
      },
      AT: {
        domain: 'derfairecredit.at',
        pknr: '3.at.100.1'
      }
    };

    function adoptNewUrlToEnvironment(environmentId, country) {
      if (environmentId === 'prod') {
        return `https://angebot.${URL_CONFIG[country].domain}/strapp/einstieg`;
      }
      if (environmentId === 'local') {
        environmentId = 'integ';
      }
      return `https://angebot.${environmentId}.${URL_CONFIG[country].domain}/strapp/einstieg`;
    }

    function setInitialFormLink(webcomponent, locationObject) {
      const country = window.tb.PROVIDED_COUNTRY;
      const env_id = window.tb.WP_ENV;

      if (extractPkFromLocation(locationObject) === '' && !window.tbNoCache.is_admin) {
        const state = history.state;
        const title = document.title;
        const url = window.location.origin + window.location.pathname;
        let search = window.location.search;
        let pkParam = `pk=${URL_CONFIG[country].pknr}`;
        search = search.indexOf('?') !== -1 ? `${search}&${pkParam}` : `?${pkParam}`;

        history.pushState(state, title, url + search + window.location.hash);
      }

      if (webcomponent.getAttribute('use-a-tag-as-cta') === null) {
        webcomponent.removeAttribute('form-link');
        webcomponent.setAttribute('form-link', adoptNewUrlToEnvironment(env_id, country));
      }
    }

    this.#calculatorsContainer.addEventListener('kreditrechner_jetzt_berechnen', (e) => {
      let usingATagAsCta = false;

      if (e.detail) {
        if (e.detail.length >= 1) {
          if (e.detail[0].handledViaCta) {
            usingATagAsCta = true;
          }
        }
      }

      const kreditRechnerElem = e.currentTarget.querySelector('[datalayer-eventname]');

      if (kreditRechnerElem !== null) {
        const dataLayerEventname = kreditRechnerElem.getAttribute('datalayer-eventname');

        if (dataLayerEventname !== null) {
          const dataLayerPage = window.location.href.replace(window.location.origin, '');

          const pushData = {
            'event': dataLayerEventname,
            'page': dataLayerPage,
            'value': getCookieFn('antrag.kreditWunsch'),
            'duration': getCookieFn('antrag.laufzeit'),
            'rate': getCookieFn('antrag.rate')
          };

          if (typeof dataLayer !== 'undefined') {
            dataLayer.push(pushData);
          }
        }
      }

      if (!usingATagAsCta) {
        const env_id = window.tb.WP_ENV;
        const country = window.tb.PROVIDED_COUNTRY;
        const pkNr = extractPkFromLocation(locationObj) === '' ? URL_CONFIG[country].pknr : extractPkFromLocation(locationObj);
        const parameterString = prepareCreditUrlParams({
          wunschbetrag: getCookieFn('antrag.kreditWunsch'),
          pk: pkNr,
          vertriebsstelle: pkNr,
        });

        window.open(adoptNewUrlToEnvironment(env_id, country) + parameterString);
      }
    });

    let component = document.querySelector('kredit-rechner');

    if (component) {
      setInitialFormLink(component, locationObj);
    } else {
      let intvalCounter = 0;

      const getComponentIntval = setInterval(() => {
        component = document.querySelector('kredit-rechner');

        if (component || intvalCounter > 100) {
          setInitialFormLink(component, locationObj);
          clearInterval(getComponentIntval);
        }

        intvalCounter++;
      }, 100);
    }
  }
}

function prepareCreditUrlParams(params) {
  const paramStrings = Object.keys(params)
    .map((paramName) => {
      return `${paramName}=${params[paramName]}`
    });
  if (paramStrings.length) {
    return '?' + [].concat(paramStrings).join('&');
  }

  return '';
}

const calculatorElements = document.querySelectorAll('[data-js-block="calculators"]');
let horseShoeImported = false;

if (calculatorElements.length > 0) {
  calculatorElements.forEach(calculatorElement => {
    const calculatorClass = new Calculators(calculatorElement);
    calculatorClass.init();
  });
}

export default Calculators;
